import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

function UserFilterDisplay({ filters }) {
  return (
    <MDBox
      id="userFilterDisplay"
      sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}
    >
      <MDBox sx={{ width: "80%", display: "flex", flexDirection: "row" }}>
        <MDBox sx={{ display: "flex", alignItems: "center" }}>
          <MDTypography sx={{ color: "#4c4c4c", fontSize: "1.6rem", mr: 1 }}>
            Export Summary:
          </MDTypography>
        </MDBox>
        {Object.keys(filters).map((key) => {
          if (Array.isArray(filters[key]) && filters[key].length > 0) {
            return (
              <MDBox sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }} key={key}>
                <MDTypography
                  variant="body1"
                  sx={{ textTransform: "capitalize", mr: 1, color: "#4c4c4c", fontSize: "1.6rem" }}
                >
                  {`${key === "reportsTo" ? "Reports To " : key}: `}
                </MDTypography>
                <MDTypography
                  variant="body1"
                  sx={{ fontStyle: "italic", color: "#7882a6", fontSize: "1.5rem", mr: 2 }}
                >
                  {Array.isArray(filters[key]) &&
                    filters[key]?.map(
                      (appliedFilter, inx) =>
                        `${appliedFilter.label} ${inx !== filters[key].length - 1 ? "," : ""} `
                    )}
                </MDTypography>
              </MDBox>
            );
          }
          if (key === "dateFilter") {
            return (
              <MDBox key={key} sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
                <MDTypography
                  variant="body1"
                  sx={{ textTransform: "capitalize", mr: 1, color: "#4c4c4c", fontSize: "1.6rem" }}
                >
                  Date:
                </MDTypography>
                <MDTypography
                  variant="body1"
                  sx={{ fontStyle: "italic", color: "#7882a6", fontSize: "1.5rem", mr: 2 }}
                >
                  {filters[key]}
                </MDTypography>
              </MDBox>
            );
          }
          return null;
        })}
      </MDBox>
      <MDBox sx={{ width: "20%" }}>
        <img
          src="/logos/Alysio-Logo-Black.svg"
          alt="Alysio logo"
          style={{ maxHeight: "100%", objectFit: "contain" }}
        />
      </MDBox>
    </MDBox>
  );
}

export default UserFilterDisplay;
